// extracted by mini-css-extract-plugin
export default {"workfromhome":"WorkFromHome_workfromhome__H+2cp","top":"WorkFromHome_top__i1qB7","container":"WorkFromHome_container__mhAbl"};